'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.setUser = setUser;
exports.loadAuth = loadAuth;
exports.login = login;
exports.loginFacebook = loginFacebook;
exports.loginGoogle = loginGoogle;
exports.loginPhone = loginPhone;
exports.loginVerifyBooking = loginVerifyBooking;
exports.openLoginFormAction = openLoginFormAction;
exports.closeLoginFormAction = closeLoginFormAction;
exports.register = register;
exports.logout = logout;
exports.resetRegisterStatus = resetRegisterStatus;

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _localStorage = require('../../utils/localStorage');

var _firebase = require('firebase');

var firebase = _interopRequireWildcard(_firebase);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'lookme/auth/LOAD';
var LOAD_SUCCESS = 'lookme/auth/LOAD_SUCCESS';
var LOAD_FAIL = 'lookme/auth/LOAD_FAIL';
var LOGIN = 'lookme/auth/LOGIN';
var LOGIN_SUCCESS = 'lookme/auth/LOGIN_SUCCESS';
var LOGIN_FAIL = 'lookme/auth/LOGIN_FAIL';
var REGISTER = 'lookme/auth/REGISTER';
var REGISTER_SUCCESS = 'lookme/auth/REGISTER_SUCCESS';
var REGISTER_FAIL = 'lookme/auth/REGISTER_FAIL';
var LOGOUT = 'lookme/auth/LOGOUT';
var SET_USER = 'lookme/auth/SET_USER';
var OPEN_LOGIN_FORM = 'lookme/auth/OPEN_LOGIN_FORM';
var CLOSE_LOGIN_FORM = 'lookme/auth/CLOSE_LOGIN_FORM';
var RESET_REGISTER_STATUS = 'lookme/auth/RESET_REGISTER_STATUS';

var initialState = {
  loaded: false,
  openLoginForm: false,
  user: null,
  registerSuccess: false,
  registerError: null,
  registeringIn: false,
  loginError: null,
  loginSuccess: null
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case SET_USER:
      return (0, _extends3.default)({}, state, {
        user: action.user
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        user: action.result.user
      });
    case LOAD_FAIL:
      (0, _localStorage.localStore)().clear('token');
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error,
        user: null,
        token: null
      });
    case LOGIN:
      return (0, _extends3.default)({}, state, {
        loggingIn: true,
        loginError: null,
        loginSuccess: null
      });
    case LOGIN_SUCCESS:
      (0, _localStorage.localStore)().set('token', action.result.token);
      _reactGa2.default.set({ userId: action.result.user._id });
      return (0, _extends3.default)({}, state, {
        loggingIn: false,
        user: action.result.user,
        token: action.result.token,
        loginSuccess: action.result
      });
    case LOGIN_FAIL:
      (0, _localStorage.localStore)().clear('token');
      _reactGa2.default.set({ userId: null });
      return (0, _extends3.default)({}, state, {
        loggingIn: false,
        user: null,
        loginError: action.error
      });
    case REGISTER:
      return (0, _extends3.default)({}, state, {
        registeringIn: true,
        registerSuccess: false,
        registerError: null
      });
    case REGISTER_SUCCESS:
      return (0, _extends3.default)({}, state, {
        registeringIn: false,
        registerSuccess: true,
        registerError: null
      });
    case REGISTER_FAIL:
      return (0, _extends3.default)({}, state, {
        registeringIn: false,
        registerSuccess: false,
        user: null,
        registerError: action.error
      });
    case RESET_REGISTER_STATUS:
      return (0, _extends3.default)({}, state, {
        registerSuccess: false,
        registerError: null
      });
    case LOGOUT:
      (0, _localStorage.localStore)().clear('token');
      _reactGa2.default.set({ userId: null });
      return (0, _extends3.default)({}, state, {
        user: null,
        token: null
      });
    case OPEN_LOGIN_FORM:
      _reactGa2.default.modalview('/login');
      return (0, _extends3.default)({}, state, {
        openLoginForm: true
      });
    case CLOSE_LOGIN_FORM:
      return (0, _extends3.default)({}, state, {
        openLoginForm: false
      });
    default:
      return state;
  }
}
function setUser(user) {
  return {
    type: SET_USER,
    user: user
  };
}
function loadAuth() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('/login/load-profile?env=web');
    }
  };
}

function login(data) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: function promise(client) {
      return client.post('/login/local?env=web', {
        data: data
      });
    }
  };
}

function loginFacebook(accessToken) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: function promise(client) {
      return client.post('/login/facebook?env=web', {
        data: {
          access_token: accessToken
        }
      });
    }
  };
}

function loginGoogle(accessToken) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: function promise(client) {
      return client.post('/login/google?env=web', {
        data: {
          access_token: accessToken
        }
      });
    }
  };
}

function loginPhone(firebaseToken) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: function promise(client) {
      return client.post('/login/firebase-phone?env=web', {
        data: {
          idToken: firebaseToken
        }
      });
    }
  };
}

function loginVerifyBooking(firebaseToken, userName) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: function promise(client) {
      return client.post('/login/firebase-phone?env=web', {
        data: { idToken: firebaseToken, userName: userName }
      });
    }
  };
}

function openLoginFormAction() {
  return {
    type: OPEN_LOGIN_FORM
  };
}

function closeLoginFormAction() {
  return {
    type: CLOSE_LOGIN_FORM
  };
}

function register(data) {
  return {
    types: [REGISTER, REGISTER_SUCCESS, REGISTER_FAIL],
    promise: function promise(client) {
      return client.post('/user/register', {
        data: data
      });
    }
  };
}

function logout() {
  var _this = this;

  return function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch) {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!firebase.auth().currentUser) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return firebase.auth().signOut();

            case 3:
              dispatch({
                type: LOGOUT
              });

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x3) {
      return _ref.apply(this, arguments);
    };
  }();
}

function resetRegisterStatus() {
  return {
    type: RESET_REGISTER_STATUS
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/auth.js
// module id = 40
// module chunks = 0